import AuthorProfilePage from "./author-profile-page.jsx";
import AuthorProfileApprovalsPage from "./author-profile-approvals-page.jsx";

// Profile editing has moved to the new CMS. The old editable "My Profile" form
// (/user-settings/edit-profile) was a SECOND, direct writer of the per-domain
// users_domain_attributes record behind article bylines — the new CMS is now the
// single profile editor. So the legacy My Profile view + editor are retired: their
// paths now render the Author Profile door (a front door into
// cms.pubninja.com/profile), same as /author-profile, so old links/bookmarks keep
// working. Rendering the door directly (rather than a redirect route) avoids any
// dependency on how this nested route group is rendered. Author Profile stays.
const userSettingsRoutes = [
  {
    path: "/user-settings/author-profile-approvals",
    name: "Author Profile Approvals",
    component: AuthorProfileApprovalsPage,
    dontShowInSideBar: true,
  },
  {
    path: "/user-settings/author-profile",
    name: "Author Profile",
    component: AuthorProfilePage,
    dontShowInSideBar: true,
  },
  {
    path: "/user-settings/edit-profile",
    name: "Edit User Profile",
    component: AuthorProfilePage,
    dontShowInSideBar: true,
  },
  {
    path: "/user-settings/profile",
    name: "My Profile",
    component: AuthorProfilePage,
    dontShowInSideBar: true,
  }
];

export default userSettingsRoutes;
